import { useEffect, useState } from 'react';
import type { SelectOption } from 'components/ui';
import { paymentModeService } from 'api/services';

/**
 * The company-wide payment modes as dropdown options (ADR-0055 §6) — Bank transfer, UPI (QR),
 * Credit card, Cheque, Cash… The value is the mode code, stored in the document's instrument_type
 * and used by bank reconciliation to expect the right charges. Falls back to the given list while
 * loading or if the call fails, and keeps a value the list does not know (an older document's).
 */
export function usePaymentModeOptions(fallback: SelectOption[], currentValue?: string | null): SelectOption[] {
  const [options, setOptions] = useState<SelectOption[]>(fallback);

  useEffect(() => {
    let cancelled = false;
    paymentModeService.getModes()
      .then(modes => {
        if (!cancelled && modes.length > 0) setOptions(modes.map(m => ({ value: m.modeCode, label: m.modeName })));
      })
      .catch(() => { /* keep the fallback */ });
    return () => { cancelled = true; };
  }, []);

  if (currentValue && !options.some(o => o.value === currentValue)) {
    return [...options, { value: currentValue, label: currentValue }];
  }
  return options;
}

export default usePaymentModeOptions;
